module.exports = __webpack_public_path__ + "static/media/AU 2019 Research Roster - Idea Exchange.596247df.xlsx";